import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0cffac79&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0cffac79&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cffac79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cffac79')) {
      api.createRecord('0cffac79', component.options)
    } else {
      api.reload('0cffac79', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0cffac79&scoped=true", function () {
      api.rerender('0cffac79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/sysParam/index.vue"
export default component.exports